/**
 * @fileoverview Present caller-supplied attorney rates, rounded hours, and matter billing totals. The backend calculation owns those quantities; `Billing.js` owns report loading and explicit resync. Table formatting does not define rounding policy or turn a billable amount into an invoice/payment.
 */

import React from 'react'
import { AppDataTable, AppColumn } from '../shared'



function BillingTable({ rows, attorneyCount }) {
    return (
        <section className="billing-panel billing-table-panel">
            <div className="billing-panel-header">
                <div>
                    <h3 className="billing-panel-title">Attorney Breakdown</h3>
                    <p className="billing-panel-description">
                        Per-attorney rates, six-minute rounded hours, and billed totals from Clockify data.
                    </p>
                </div>
                <div className="billing-panel-metric billing-panel-metric--count">
                    {attorneyCount}
                </div>
            </div>

            <div className="billing-table-frame">
                <AppDataTable
                    value={rows}
                    size="small"
                    stripedRows
                    emptyMessage="No attorney billing breakdown available."
                >
                    <AppColumn sortable field="name" header="Attorney" />
                    <AppColumn sortable field="rateDisplay" sortField="rateValue" header="Rate" />
                    <AppColumn sortable field="hoursDisplay" sortField="hoursValue" header="Hours" />
                    <AppColumn sortable field="billDisplay" sortField="billValue" header="Bill" />
                </AppDataTable>
            </div>
        </section>
    )
}

export default BillingTable
